import { createContext } from 'react';

export const AuthContext = createContext();
export const AuthenticationContext = createContext();
export const AppContext = createContext();
export const RoutesContext = createContext();
export const UploadFilesContext = createContext();
export const DownloadFilesContext = createContext();
